
/* injects from baggage-loader */

export const balloons = [
    'Bem-vindo(a) à <b>Região Centro-oeste</b>!<br> O centro do Brasil é conhecido por suas grandes fazendas, pela beleza do Pantanal e por sua culinária diversificada.',
    'O cardápio a seguir tem<br>  muitos pratos típicos do Centro-oeste! <br>Você deve escutar o pedido do cliente e registrá-lo no tablet! ']




// WEBPACK FOOTER //
// ./src/app/pages/stage-fifth/stage-fifth.const.js